import React from "react";
import { Link } from "react-router-dom";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";

const Introduction = () => {
  return (
    <div
      className="introduction "
      data-aos="fade-right"
      data-aos-delay="300"
      data-aos-duration="1000"
    >
      <h1 className="title">Introduction</h1>
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/HrIke_qj24o"
          title="How to upload project to server"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      <h3 className="introduction-title">Overview</h3>
      <strong className="introduction-subTitle">
        Welcome to - <strong className="strong">Sundaymart.</strong>
      </strong>

      <div>
        Sundaymart is a multi shop marketplace, full solution ( apps, web,
        admin) developed by applying Laravel, React Js , Next Js and Flutter
        Frameworks. <br />
        Laravel is an open-source PHP Framework intended for the development of
        web applications which is a complete toolset, robust, yet easy to
        understand with an excellent, expressive syntax. <br />
        Next.js is an open-source web development framework created by Vercel
        enabling React-based web applications with server-side rendering and
        generating static websites.
        <br />
        React (also known as React.js or ReactJs) is a free and open-source
        front-end JavaScript library[3] for building user interfaces based on UI
        components.
        <br />
        Flutter is an open-source framework for mobile application development
        created by Google. It is applied to develop multi-platform, natively
        compiled applications for Android and iOS.
        <div className="line-break" />
        Sundaymart consists of 2 Mobile Applications, 5 Web Panel, 1 website:
        <br />
        <div className="introduction-img-container">
          <SimpleReactLightbox>
            <SRLWrapper>
              <a
                href="/assets/img/doc/admin-main.png"
                data-fancybox
                rel="nofollow"
              >
                <img
                  src="/assets/img/doc/admin-main.png"
                  alt="admin"
                  loading="lazy"
                  className="img-responsive-full"
                />
              </a>
            </SRLWrapper>
          </SimpleReactLightbox>
          <SimpleReactLightbox>
            <SRLWrapper>
              <a
                href="/assets/img/doc/web-main.png"
                data-fancybox
                rel="nofollow"
              >
                <img
                  src="/assets/img/doc/web-main.png"
                  alt="web main"
                  loading="lazy"
                  className="img-responsive-full"
                />
              </a>
            </SRLWrapper>
          </SimpleReactLightbox>
        </div>
        <div className="line-break" />
        <h3 className="introduction-contentTitle">
          2 Apps developed using Flutter
        </h3>
        • Customer application <br />
        • Delivery Boy application <br />
        <h3 className="introduction-contentTitle">
          5 web panel developed using Laravel and React Js
        </h3>
        • Admin web panel
        <br />
        • Manager web panel <br />
        • Store web panel <br />
        • Moderator web panel <br />
        • Delivery boy web panel <br />
        <h3 className="introduction-contentTitle">
          1 web site developed using Next Js
        </h3>
        • Customer web site <br />
        <div className="line-break" />
      </div>

      <div className="next-page-container">
        <Link
          to="/sundaymart-documentation/recommendations"
          className="btn  next"
        >
          <p>Next</p>
          <p className="link"> Recommendations </p>
        </Link>
      </div>
    </div>
  );
};

export default Introduction;
